/**
 * Shared variant picker renderer for every sheet (quick-view, shop-the-look,
 * shop-the-look-editorial, set-builder, product-quiz, shop-the-videos, cart
 * upsell). Produces the quick-view-style selector markup so all sheets look
 * identical. Callers keep their own availability/resolve logic and build the
 * `blocks` data; this module only renders markup.
 *
 * Value buttons carry standardized hooks: data-vp-pi, data-vp-oi, data-vp-val.
 * Unavailable values get aria-disabled="true" (not the native disabled attr) so
 * callers can intercept the click and ignore it.
 */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }

  // Light swatches take a dark check; everything else a white check (mirrors the
  // product page + quick-view behaviour).
  var LIGHT = 'white,cream,ivory,beige,sand,gold,silver,khaki,tan,camel,mustard,dawn pink,pink,blush,sage,gold/cream,off white,off-white,natural,pearl,bone,wheat,ecru,oatmeal,champagne';
  function checkColor(name) {
    return LIGHT.indexOf(String(name == null ? '' : name).trim().toLowerCase()) >= 0 ? '#1a1a1a' : '#ffffff';
  }

  function renderValue(v, pi, oi, isColor) {
    var cls = (v.selected ? ' is-selected' : '') + (v.available ? '' : ' is-unavailable');
    var data = ' data-vp-pi="' + pi + '" data-vp-oi="' + oi + '" data-vp-val="' + esc(v.value) + '"';
    var dis = v.available ? '' : ' aria-disabled="true"';
    if (isColor) {
      var token = String(v.value == null ? '' : v.value).trim().toLowerCase();
      var stl = v.hex ? ' style="background:' + esc(v.hex) + '"' : '';
      return '<button type="button" class="vpick__swatch' + cls + '"' + data + dis +
        ' title="' + esc(v.value) + '" aria-label="' + esc(v.value) + (v.available ? '' : ' (out of stock)') + '">' +
        '<span class="vpick__chip" data-color-name="' + esc(token) + '"' + stl + '></span>' +
        '<i class="ph-bold ph-check vpick__check" aria-hidden="true" style="color:' + checkColor(v.value) + ';"></i>' +
        '</button>';
    }
    return '<button type="button" class="vpick__pill' + cls + '"' + data + dis + '>' + esc(v.value) + '</button>';
  }

  function renderGroup(opt, pi) {
    var values = opt.values.map(function (v) { return renderValue(v, pi, opt.oi, opt.isColor); }).join('');
    return '<div class="vpick__group"><div class="vpick__label">' + esc(opt.name) +
      (opt.isColor && opt.selected ? '<span class="vpick__selected">' + esc(opt.selected) + '</span>' : '') +
      '</div><div class="vpick__values">' + values + '</div></div>';
  }

  function renderGroups(block) {
    return block.options.map(function (o) { return renderGroup(o, block.pi); }).join('');
  }

  function renderProduct(block) {
    return '<div class="vpick__product">' +
      (block.image ? '<img class="vpick__pimg" src="' + esc(block.image) + '" alt="" loading="lazy">' : '') +
      '<div class="vpick__pbody">' +
      (block.title ? '<div class="vpick__ptitle">' + esc(block.title) + '</div>' : '') +
      renderGroups(block) +
      '</div></div>';
  }

  /**
   * @param blocks Array of { pi, title?, image?, options: [{ name, oi, isColor,
   *   selected (string|null), values: [{ value, selected, available, hex? }] }] }
   * @param opts {
   *   bare?        — render only the option groups (no product wrapper / intro / CTA). Used by quick-view.
   *   intro?       — intro paragraph text.
   *   addAttr?     — data hook for the CTA (e.g. 'data-stl-sheet-add'). When present a CTA is rendered.
   *   addLabel?, selectLabel?, ready? — CTA label + enabled state.
   * }
   * @returns {string} HTML
   */
  function renderVariantPicker(blocks, opts) {
    opts = opts || {};
    if (opts.bare) {
      return blocks.map(renderGroups).join('');
    }
    var html = '';
    if (opts.intro) html += '<p class="vpick__intro">' + esc(opts.intro) + '</p>';
    html += blocks.map(renderProduct).join('');
    if (opts.addAttr != null) {
      html += '<button type="button" class="ui-sheet__btn ui-sheet__btn--primary ui-sheet__btn--block vpick__add" ' +
        opts.addAttr + (opts.ready ? '' : ' disabled') + '>' +
        esc(opts.ready ? opts.addLabel : opts.selectLabel) + '</button>';
    }
    return html;
  }

  window.UntamedSheets = window.UntamedSheets || {};
  window.UntamedSheets.renderVariantPicker = renderVariantPicker;
})();
